// extracted by css-extract-rspack-plugin
export default {"resourceColHeader":"styles_resourceColHeader__csnBI","cta":"styles_cta__jUKie","cellWrap":"styles_cellWrap__IfVQl","editIcon":"styles_editIcon__sbMhl"};